// Libs
import * as React from "react";
import { connect } from "react-redux";
import { withRouter, RouteComponentProps } from "react-router";
import styled from "styled-components";
import Grid from "@material-ui/core/Grid";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
// Components
import ClassesCard from "./ClassesCard";
import FixedFabButton from '../shared/FixedFabButton'
// Helpers
import { IStoreState } from "../lib/interface";
// Store
import { selectClass, deselectClass } from "./duck/actions";

interface IProps extends RouteComponentProps<{}> {
  classSelections: number[];
  classesData: any[];
  deselectClass: (id: number) => void;
  selectClass: (id: number) => void;
}

const Classes: React.SFC<IProps> = (props) => {
  const { classesData, classSelections , history} = props

  function handleCardSelect (id: number) {
    if (classSelections.find((classId: number) => classId === id)) {
      props.deselectClass(id);
    } else {
      props.selectClass(id);
    }
  }

  function next () {
    history.push("/views/new/factoids");
  }
  
  function renderCards ()  {
    return classesData.map((item: any) => {
      // Class items parent is 0 which means it's an asset class
      if (!item.parent) {
        const active = classSelections.find(
          (classId: number) => classId === item.id
        )
          ? true
          : false;
        return (
          <Grid item={true} xs={12} md={4} key={item.id}>
            <ClassesCard
              item={item}
              onCardSelect={handleCardSelect}
              selected={active}
            />
          </Grid>
        );
      } else {
        return;
      }
    });
  };

  return (
    <Outer>
    <Grid container={true} spacing={24} style={{marginTop: '30px'}}>
      {renderCards()}
    </Grid>
    <FixedFabButton
      onClick={next}
      disabled={!classSelections.length ? true : false}
    >
      <ArrowForwardIcon />
    </FixedFabButton>
    </Outer>
  )
}


const Outer = styled.div`
  width: 95%;
  margin: 0 auto;
  position: relative;
  h2 {
    color: #717271;
    font-weight: 400;
  }
`;

const mapStateToProps = (state: IStoreState) => ({
  classSelections: state.views.new.selections.classes,
  classesData: state.data.classes
});

export default withRouter(
    connect(
      mapStateToProps,
      { selectClass, deselectClass }
    )(Classes)
);



// WEBPACK FOOTER //
// ./src/views/Classes.tsx